import { GetString } from 'fluent-react';
import React from 'react';
import PresentationManager from '../../presentationManager/PresentationManager';
import {
  Root,
} from '../Grid';
import ContentBackground from '../landing/Background';
import {
  defaultVerticalSlideTransition,
  getUniqueSlideElementKey,
  SlideName,
} from '../Utils';
import MainContent from './MainContent';

interface Input {
  countryId: string;
  selectCountry: (country: string) => void;
  getFluentString: GetString;
  backgroundZIndex: number;
  contentZIndex: number;
  slideIndex: number;
  year: number;
  goToPrevSlide: () => void;
}
const getConclusionSlide = (input: Input) => {
  const {
    getFluentString,
    countryId, selectCountry,
    backgroundZIndex, contentZIndex,
    slideIndex, year, goToPrevSlide,
  } = input;

  return (
    <PresentationManager RootComponent={Root} slideIndex={slideIndex}>
      <ContentBackground
        zIndex={backgroundZIndex}
        transition={defaultVerticalSlideTransition}
        key={getUniqueSlideElementKey(SlideName.Conclusion, 'background')}
      />
      <MainContent
        rootZIndex={contentZIndex}
        getFluentString={getFluentString}
        countryId={countryId}
        selectCountry={selectCountry}
        year={year}
        goToPrevSlide={goToPrevSlide}
        transition={defaultVerticalSlideTransition}
        key={getUniqueSlideElementKey(SlideName.Conclusion, 'main-content')}
      />
    </PresentationManager>
  );
};

export default getConclusionSlide;
